import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-who-we-are',
  templateUrl: './footer-who-we-are.component.html',
  styleUrls: ['./footer-who-we-are.component.scss']
})
export class FooterWhoWeAreComponent {
    //#region Public Variables
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    private urlLearnMorePage : string = 'https://www.rawlingsgroup.com/';
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    //#endregion Constructor

    //#region Public Methods
    public OnClickLearnMore(): void {
        window.open(this.urlLearnMorePage);
    }
    //#endregion Public Methods
}
